const formatError = (error?: string | string[]): string => {
    if (Array.isArray(error)) {
        return error.join(', ');
    }
    return error;
};

export default formatError;
